export default __webpack_public_path__ + "menu-banners-smop-icon.037c5124b450fc6a99b6043a5b949b98.svg";